import { Images } from "../assets";

const FundingBanner = () => {
  return (
    <div className="bg-surface flex flex-row items-center h-[80px] px-[120px] gap-[40px] opacity-100">
      <img
        className="h-[40px]"
        src={Images.madeInFinland}
        alt="Made in Finland"
      />
      <img
        className="h-[36px]"
        src={Images.fundedByEuUnion}
        alt="Funded by EU Union"
      />
    </div>
  );
};

export default FundingBanner;
